import React, { useMemo } from 'react';
import { Table } from 'antd';
import './shapeTable.css';
import { ItemsEnum } from '../../Utils/enum';

const ShapeTable = ({ formValues }) => {

    const dataSource = useMemo(() => {
        const imageCountMap = formValues.images.reduce((acc, image) => {
            const item = ItemsEnum[image.title];
            if (item) {
                if (acc[item.title]) {
                    acc[item.title].count += 1;
                } else {
                    acc[item.title] = { ...item, count: 1 };
                }
            }
            return acc;
        }, {});

        return Object.values(imageCountMap);
    }, [formValues.images]);

    const columns = [
        {
            title: 'Item',
            dataIndex: 'icon',
            key: 'icon',
            render: (url, record) => (
                <img src={record.icon} className="shape-icon" alt={record.title} />
            ),
            align: 'center',
        },
        {
            title: 'Type',
            dataIndex: 'title',
            key: 'type',
            align: 'center',
        },
        {
            title: 'Count',
            dataIndex: 'count',
            key: 'count',
            align: 'center',
        },
    ];

    return (
        <Table
            className="shapes-table"
            dataSource={dataSource}
            columns={columns}
            rowKey="title" 
            pagination={false}
        />
    );
};

export default ShapeTable;
